import gql from 'graphql-tag'

export default gql`
mutation updateUser($record:UpdateByIdUserInput!){
  updateUser(record:$record){
    recordId
  }
}`
